<div
	class="search-container"
	[class.is-inline]="isInline()"
	[class.disabled]="disabled()"
	[class.active]="hasFocus()"
	*transloco="let t"
>
	<base-input
		#baseInput
		[class]="inputClasses()"
		type="text"
		[label]="label()"
		[placeholder]="`${t(placeholder())}...`"
		[disabled]="disabled()"
		[rightContentClickable]="true"
		(focused)="onFocus()"
		(blured)="onBlur()"
		(changed)="handleValueChange($event)"
		(keyup.enter)="handleEnter()"
		(keydown.arrowdown)="handleArrowKey($event, 1)"
		(keydown.arrowup)="handleArrowKey($event, -1)"
	>
		@if (isLoading()) {
			<circular-loader left-content [size]="16" />
		} @else {
			<base-icon left-content [icon]="SearchIcon" class="search-icon" />
		}

		@if (term().length) {
			<base-icon
				right-content
				class="clear-icon"
				[icon]="ClearIcon"
				(mousedown)="handleClearClick($event)"
			/>
		}
	</base-input>

	@if (showResults()) {
		<div class="results-dropdown" [class.is-inline]="isInline()">
			<ng-content select="[results]" />
		</div>
	}

	@if (showEmptyState()) {
		<div class="results-dropdown" [class.is-inline]="isInline()">
			<ng-content select="[empty]">
				<div class="empty-item">
					<span class="truncate-text">{{ t('message.info.noResultsFound') }}</span>
				</div>
			</ng-content>
		</div>
	}
</div>
